import { resolveAlgoliaSearchIndex } from '@atlassian/mpac-utils';
export const getAlgoliaConfig = (algoliaConfig, featureFlags, setV2SearchIndex) => {
  const searchIndex = resolveAlgoliaSearchIndex(algoliaConfig.environment, setV2SearchIndex || (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.enableV2SearchIndex));
  return {
    algoliaApiKey: algoliaConfig.apiKey,
    algoliaAppId: algoliaConfig.applicationId,
    algoliaSearchIndex: searchIndex
  };
};